/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_no_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Žádné objednávky`
};

const da_no_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Ingen ordrer`
};

const de_no_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Keine Bestellungen`
};

const en_no_orders = /** @type {(inputs: {}) => string} */ () => {
	return `No orders`
};

const es_no_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Sin pedidos`
};

const fr_no_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Aucune commande`
};

const hu_no_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Nincsenek rendelések`
};

const it_no_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Nessun ordine`
};

const nl_no_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Geen bestellingen`
};

const pl_no_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Brak zamówień`
};

const pt_no_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Nenhum pedido`
};

const sv_no_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Inga beställningar`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const no_orders = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.no_orders(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("no_orders", locale)
	if (locale === "cs") return cs_no_orders(inputs)
	if (locale === "da") return da_no_orders(inputs)
	if (locale === "de") return de_no_orders(inputs)
	if (locale === "en") return en_no_orders(inputs)
	if (locale === "es") return es_no_orders(inputs)
	if (locale === "fr") return fr_no_orders(inputs)
	if (locale === "hu") return hu_no_orders(inputs)
	if (locale === "it") return it_no_orders(inputs)
	if (locale === "nl") return nl_no_orders(inputs)
	if (locale === "pl") return pl_no_orders(inputs)
	if (locale === "pt") return pt_no_orders(inputs)
	return sv_no_orders(inputs)
};